import { createContext, useContext } from 'react';
import { StudentApplicationValues } from '../../student/application/StudentApplication';

export type ApplicationProgress<T> = { progress: number } & {
  [K in keyof T]?: T[K] extends object ? ApplicationProgress<T[K]> : { progress: number };
};

type ApplicationContextType = {
  // In the future this will also accept the values for the HF and LC applications
  setApplicationData: (data: StudentApplicationValues) => void;
  setApplicationPageData: (page: keyof StudentApplicationValues, data: StudentApplicationValues[keyof StudentApplicationValues]) => void;
  applicationData: StudentApplicationValues;
  applicationProgress?: ApplicationProgress<StudentApplicationValues>;
  triggerErrors: () => void;
  displayErrors: boolean;
};

export const ApplicationContext = createContext<ApplicationContextType | undefined>(undefined);

export const useApplicationContext = (): ApplicationContextType => {
  const context = useContext(ApplicationContext);
  if (context === undefined) {
    throw new Error('useApplicationContext must be used within a ApplicationProvider');
  }
  return context;
};
